<script setup lang="ts">
import Typography from '@components/Typography.vue';
import type { Url } from '@global-types/url.ts';
import Icon from '@components/Icon.vue';
import { IconArrowRight } from '@icons';

defineProps<{ link: Url }>();
</script>

<template>
  <a
    :href="link"
    :class="[
      'w-fit',
      'p-2',
      'flex items-center space-x-2',
      'no-underline hover:underline hover:decoration-black'
    ]"
  >
    <Typography variant="body-bold">
      <slot />
    </Typography>

    <Icon
      :svg="IconArrowRight"
      width="16"
      height="16"
    />
  </a>
</template>
